import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { DataGrid } from '@mui/x-data-grid';
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function IpBillIns(props){

  const {ip_id} = useParams();
  const [inputValue, setInputValue] = useState('');
  const [ipData, setIpData] = useState([]);
  const [labData, setLabData] = useState([]);
  const [invData, setInvData] = useState([]);
  const [drugData, setDrugData] = useState([]);
  const [minviewData, setMinviewData] = useState([]);
  const [totData, setTotData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [advData, setAdvData] = useState([]);
  const [insurData, setInsurData] = useState([]);
  const [iprefundData, setIprefundData] = useState([]);
  const [hospData, setHospData] = useState([]);
  const currentDate = new Date().toISOString().slice(0,10);
  const [viewPharmData, setViewPharmData] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
      .then(response => {
        setIpData([response.data]);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchHosData();
  }, []);
  async function fetchHosData() {
      try {
        const response = await axios.get(baseUrl + "view-hospital/" + userLocation + "/");
        setHospData(response.data);
      } catch (error) {
        console.log(error);
      }
  }


  useEffect(() => {
    fetchTotData();
  }, []);

  function fetchTotData() {
    axios.get(`${baseUrl}view-ip-tot/${ip_id}`)
      .then((totResponse) => {
        setTotData(totResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchadvData();
  }, []);

  function fetchadvData() {
    axios.get(`${baseUrl}view-ip-adv/${ip_id}`)
      .then((advResponse) => {
        setAdvData(advResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchdrugData();
  }, []);
useEffect(() => {
    fetchinsurData();
  }, []);

  function fetchinsurData() {
    axios.get(`${baseUrl}view-pre-insur/${ip_id}`)
      .then((insResponse) => {
              const filteredData = insResponse.data.filter(item => item.status == 1);
                      console.log('Filtered Data:', filteredData); // Debugging step
              setInsurData(filteredData);
      })
      .catch(error => {
        console.log(error);
      });
  }
  function fetchdrugData() {
    axios.get(`${baseUrl}view-ip-drug/${ip_id}`)
      .then((drugResponse) => {
        setDrugData(drugResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
     useEffect(() => {
      if (drugData.length > 0) {
        fetchPhData();
      }
    }, [drugData]);

function fetchPhData() {
  const ipIds = drugData.map(row => row.product.split(',').map(item => item.trim()));

  ipIds.forEach(ipId => {
    try {
      ipId.forEach(id => {
        axios.get(baseUrl + 'update-indent-use-bill/' + id + '/')
          .then(function (response) {
            const data = Object.assign({}, response.data);
            setViewPharmData(prevData => [...prevData, data]);
          })
          .catch(function (error) {
            console.log(error);
          });
      });
    } catch (error) {
      console.log(error);
    }
  });
}


  useEffect(() => {
    fetchlabData();
  }, []);

  function fetchlabData() {
    axios.get(`${baseUrl}view-ip-lab/${ip_id}`)
      .then((labResponse) => {
        setLabData(labResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchinvData();
  }, []);

  function fetchinvData() {
    axios.get(`${baseUrl}view-ip-inv/${ip_id}`)
      .then((invResponse) => {
        setInvData(invResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchminviewData();
  }, []);

  function fetchminviewData() {
    axios.get(`${baseUrl}view-ip-min/${ip_id}`)
      .then((minviewResponse) => {
        setMinviewData(minviewResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
      fetchIprefData();
  }, []);

  async function fetchIprefData() {
      try {
          const iprefResponse = await axios.get(`${baseUrl}view-ip-refund/${ip_id}`);
          const status = (iprefResponse.data[0]?.refund_status);
          if(status == 2){
          setIprefundData(iprefResponse.data);
          }
      } catch (error) {
        console.log(error);
      }
  }

    let drugTotalSum = 0;
    let drugPaidSum = 0;
    for (let i = 0; i < drugData.length; i++) {
      drugTotalSum += parseFloat(drugData[i].total);
      if(drugData[i].mode != 'advance') {
        drugPaidSum += parseFloat(drugData[i].paid) || 0;
      }
    }
    let insurTotalSum = 0;
    for (let i = 0; i < insurData.length; i++) {
      insurTotalSum += parseFloat(insurData[i].app_amount);
    }
    let labTotalSum = 0;
    let labPaidSum = 0;
    for (let i = 0; i < labData.length; i++) {
      labTotalSum += parseFloat(labData[i].lab_tot);
      if(labData[i].lab_pmode != 'advance') {
        labPaidSum += parseFloat(labData[i].lab_paid) || 0;
      }
    }
    let invTotalSum = 0;
    let invPaidSum = 0;
    for (let i = 0; i < invData.length; i++) {
      invTotalSum += parseFloat(invData[i].inv_tot);
      if(invData[i].inv_pmode != 'advance') {
        invPaidSum += parseFloat(invData[i].inv_paid) || 0;
      }
    }
    let advTotalSum = 0;
    let advPaidSum = 0;
    for (let i = 0; i < advData.length; i++) {
      advTotalSum += parseFloat(advData[i].advance);
      advPaidSum += parseFloat(advData[i].paid) || 0;
    }
    let minviewTotalSum = 0;
    for (let i = 0; i < minviewData.length; i++) {
      minviewTotalSum += parseFloat(minviewData[i].min_tot);
    }
    let refTotalSum = 0;
    for (let i = 0; i < iprefundData.length; i++) {
      refTotalSum += parseFloat(iprefundData[i].refund_amount);
    }

    minviewTotalSum = parseFloat(minviewTotalSum) || 0;
    invTotalSum = parseFloat(invTotalSum) || 0;
    labTotalSum = parseFloat(labTotalSum) || 0;
    drugTotalSum = parseFloat(drugTotalSum) || 0;

    const InvoicedTotal = minviewTotalSum + invTotalSum + labTotalSum + drugTotalSum;
    const PaidTotal = parseFloat(advPaidSum) + parseFloat(drugPaidSum) + parseFloat(invPaidSum) + parseFloat(labPaidSum) + parseFloat(insurTotalSum) - parseFloat(refTotalSum)
    const totdisc = totData.map(row => row.tot_disc);
    const BalanceTotal = parseFloat(InvoicedTotal)

    const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
     };

    return (
    <section className="container mt-4">
    <div  id="invoice-print">
      <table rules="rows" cellpadding="3" className="text-justify mt-5" width="100%" >
        <thead>
          <tr>
            {hospData.map((hospital) => (
                <td align="right" colSpan="2" >
                  <p align="center">
                 <img
  src={hospital.logo}
  alt="Hospital Logo"
  style={{width:"60px", height:"60px", objectFit:"contain"}}
/>
<strong>{hospital.hospital}</strong><br />
                    Address&nbsp;: &nbsp;{hospital.address}&nbsp;&nbsp;&nbsp;-&nbsp;
                    <br />Phone : {hospital.mobile} &nbsp; Email : {hospital.email} &nbsp; <br />
                    Web : {hospital.website}
                  </p>
                </td>
            ))}
          </tr>
        </thead>
        </table>
    <h4 style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', justifyContent: 'space-between' }}>
      <span style={{ alignSelf: 'flex-start' }}>INSURANCE BILL/ RECEIPT- IPB-000{ipData.map(row => row.id)}</span>
      <span style={{ alignSelf: 'flex-end' }}>Date : {currentDate}</span>
    </h4>
    <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient</th>
          <th>IP ID</th>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
          <th>Admit On/Discharged On</th>
        </tr>
      </thead>

      <tbody>
        {ipData.map((patientData, index) => (
          <tr >
          <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/></td>
            <td>{patientData.ip_id}</td>
            <td>{patientData.pat.pat_id}</td>
            <td>{patientData.pat.patient}</td>
            <td>{patientData.pat.gender}</td>
            <td>{patientData.pat.age}</td>
            <td>{patientData.pat.mobile}</td>
            <td>{ formatDateTime(patientData.admit_date)}</td>
            <td>
  {formatDateTime(patientData.admit_date)}
  {patientData?.discharge_time ? ` / ${formatDateTime(patientData.discharge_time)}` : ''}
</td>

          </tr>
        ))}
      </tbody>
    </table>
    </div>
    <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Insurance Type</th>
          <th>Insurance Compy</th>
          <th>Policy No</th>
          <th>Card No</th>
        </tr>
      </thead>

      <tbody>

          <tr>
          {ipData.map((insData, index) => (
            <React.Fragment key={`insData-${index}`}>
              <td>{insData.insur_cmpy.type.type}</td>
              <td>{insData.insur_cmpy.company}</td>
            </React.Fragment>
          ))}
          {insurData.map((polData, index) => (
            <React.Fragment key={`polData-${index}`}>
              <td>{polData.policyno}</td>
              <td>{polData.cardno}</td>
            </React.Fragment>
          ))}
        </tr>

      </tbody>
    </table>
    </div>
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true" style={{ color: 'red' }}></i>
      Billing Summary
    </h3>


<div className="collapse show" id="collapseMin">
  <div className="card card-body">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>IP Bill Test</th>
          <th>Amount</th>
          
          <th>Invoiced</th>
        </tr>
  </thead>
  <tbody>
    {minviewData.map((min, index) => (
  <tr key={index}>
    <td>
      {min.min_test.split(',').map((item, idx) => (
        <div key={idx}>{item.trim()}</div>
      ))}
    </td>
     <td>
              {min.min_amount.split(',').map((amount, i) => (
                <React.Fragment key={i}>
                  {amount.trim()} * {min.min_units?.split(',')[i].trim()} =
                  {(parseFloat(amount.trim()) * parseFloat(min.min_units?.split(',')[i].trim()))}
                  {i < min.min_amount.split(',').length - 1 && <br />}
                </React.Fragment>
              ))}
            </td>
    
    <td>{min.min_tot}</td>
  </tr>
))}

    </tbody>
    </table>
  </div>
</div>
<p>
<button className="btn btn-info w-100 d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMin" aria-expanded="true" aria-controls="collapseMin">
  <span className="text-start">+ IP Bill</span>
  <span className="text-end">Rs.{minviewTotalSum.toFixed(2)}</span>
</button>
</p>
<>
{labData && labData.length > 0 && (
    <>

<div className="collapse show" id="collapseLab">
  <div className="card card-body">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Lab Test</th>
          <th>Lab Amount</th>
          <th>Lab Invoiced</th>
          <th> Invoice No</th>
          <th>Lab Paid</th>
          <th>Lab Balance</th>
        </tr>
  </thead>
  <tbody>
    {labData.map((lab, index) => (

          <tr key={index}>
            <td>
              {lab.lab_test.split(',').map((item, idx) => (
                <div key={idx}>{item.trim()}</div>
              ))}
            </td>
            <td>
              {lab.lab_amount.split(',').map((item, idx) => (
                <div key={idx}>{item.trim()}</div>
              ))}
            </td>
            <td>{lab.lab_invoice}</td>
            <td>{lab.lab_tot}</td>
            <td>{lab.lab_paid}</td>
            <td>{lab.lab_balance}</td>
          </tr>
        ))}
    </tbody>
    </table>
  </div>
</div>
<p>
<button className="btn btn-info w-100 d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseLab" aria-expanded="true" aria-controls="collapseLab">
  <span className="text-start">+ Lab</span>
  <span className="text-end">Rs.{labTotalSum.toFixed(2)}</span>
</button>

</p>
</>
)}
</>
<>
{invData && invData.length > 0 && (
    <>
<div className="collapse show" id="collapseInv">
  <div className="card card-body">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Inv Test</th>
          <th>Inv Amount</th>
          <th>Inv Invoiced</th>
          <th>Inv Invoice No</th>
          <th>Inv Paid</th>
          <th>Inv Balance</th>
        </tr>
  </thead>
  <tbody>
    {invData.map((inv, index) => (
          <tr key={index}>
            <td>
              {inv.inv_test.split(',').map((item, idx) => (
                <div key={idx}>{item.trim()}</div>
              ))}
            </td>
            <td>
              {inv.inv_amount.split(',').map((item, idx) => (
                <div key={idx}>{item.trim()}</div>
              ))}
            </td>
            <td>{inv.inv_invoice}</td>
            <td>{inv.inv_tot}</td>
            <td>{inv.inv_paid}</td>
            <td>{inv.inv_balance}</td>
          </tr>
        ))}
    </tbody>
    </table>
  </div>
</div>
<p>
<button className="btn btn-info w-100 d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseInv" aria-expanded="true" aria-controls="collapseInv">
  <span className="text-start">+ Radiology</span>
  <span className="text-end">Rs.{invTotalSum.toFixed(2)}</span>
</button>
</p>
</>
)}
</>
<>
{drugData && drugData.length > 0 && (
    <>
<div className="collapse show" id="collapseDrug">
  <div className="card card-body">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Drug</th>
          <th>Amount</th>
          <th>Invoiced</th>
          <th>Paid</th>
          <th>Balance</th>
          <th>Invoice</th>
          <th>Mode</th>
        </tr>
  </thead>
  <tbody>

    {drugData.map((drug, index) => {
              const productArray = drug.product.split(',');
              const qtyArray = drug.qty.split(',');
              const rows = productArray.map((test, subIndex) => {
                const pharmData = viewPharmData.find((data) => data.id == test);
                const isFirstRow = subIndex === 0;
                const rowspan = isFirstRow ? productArray.length : undefined;

                return (
                  <tr key={`${index}-${subIndex}`} style={{ border: "1px solid", borderColor: "#2194d9" }}>
                    <td>{pharmData?.product.product}</td>
                    <td>{pharmData?.product.uamount} * {qtyArray[subIndex]}</td> 
                    {isFirstRow && <td rowSpan={rowspan}>{drug.total}</td>}
                    {isFirstRow && <td rowSpan={rowspan}>{drug.paid}</td>}
                    {isFirstRow && <td rowSpan={rowspan}>{drug.balance}</td>}
                    {isFirstRow && <td rowSpan={rowspan}>{drug.sale_id}</td>}
                    {isFirstRow && <td rowSpan={rowspan}>{drug.mode}</td>}
                  </tr>
                );
              });
              return rows;
            })}

    </tbody>
    </table>
  </div>
</div>
<p>
<button className="btn btn-info w-100 d-flex justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDrug" aria-expanded="true" aria-controls="collapseDrug">
  <span className="text-start">+ Drug</span>
  <span className="text-end">Rs.{drugTotalSum.toFixed(2)}</span>
</button>
</p>
</>
)}
</>
    <>
   {insurData && insurData.length > 0 && (
    <>
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true" style={{ color: 'red' }}></i>
      Insurance Details
    </h3>
    <div className="table-responsive">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Insurance Type</th>
          <th>Claim Date</th>
          <th>CCN No</th>
          <th>Claimed By</th>
          <th>Est Amount</th>
          <th>Pending Amount</th>
          <th>Approved Amount</th>
          <th>Reason</th>
        </tr>
  </thead>
  <tbody>
    {insurData.map((ins, index) => {
            const pdamt = parseFloat(ins.est_amount-ins.app_amount);
            const instype = ipData.map(row => row.insur_cmpy.company);
          return (
            <tr key={index}>
            <td>{instype}</td>
            <td>{ins.ccn}</td>
            <td>{ins.app_date}</td>
            <td>{ins.addedby}</td>
            <td>{ins.est_amount}</td>
            <td>{pdamt}</td>
            <td>{ins.app_amount}</td>
            <td>{ins.reason}</td>
          </tr>
          );
    })}
    </tbody>
    </table>
    </div>
    </>
    )}
    </>
    <>
    {iprefundData && iprefundData.length > 0 && (
    <>
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true" style={{ color: 'red' }}></i>
      Refund Details
    </h3>
    <div className="table-responsive">
  <table className="erp-table-modern">
  <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Refund Type</th>
          <th>Refund Amount</th>
          <th>Receipt</th>
          <th>Received By</th>
          <th>Reason</th>
        </tr>
  </thead>
  <tbody>
    {iprefundData.map((ref, index) => (
          <tr>
            <td>{ref.refund_type}</td>
            <td>{ref.refund_amount}</td>
            <td><Link to={`/refund-invoice-ip/${ref.receipt}`} target="_blank">{ref.receipt}</Link></td>
            <td>{ref.receivedby}</td>
            <td>{ref.reason}</td>
          </tr>
    ))}
    </tbody>
    </table>
    </div>
    </>
    )}
    </>
    <h4 style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', justifyContent: 'space-between' }}>
      <span style={{ alignSelf: 'flex-start' }}>Balance Amount</span>
      <span style={{ alignSelf: 'flex-end' }}>Rs.{BalanceTotal.toFixed(2)}</span>

    </h4>
    <table border='1' width="100%">
  <thead>
    <tr>
      <th className="text-end"><strong>For {hospData.map(row => row.hospital)}</strong></th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td width="100%">
        <table width="100%">
          <tr>
            <th width="100%" className="text-end">Authorized Staff:</th>
          </tr>
          <tr>
            <th width="100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
          </tr>
          <tr>
            <th width="100%" className="text-end">(Name & Signature)</th>
          </tr>
        </table>
      </td>
    </tr>
  </tbody>
</table>
</div>
     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="mt-2">
      <button style={{ padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff' }}
      onClick={handlePrint}
      >
       Print
      </button>
    </div>
    </section>
    )
}

export default IpBillIns;